import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  yupEmail,
  yupFirstName,
  yupLastName,
  yupPassword,
  yupPhone
} from "../../../utils/validation";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions, CourierText } from "../ui/courier-fields";

const CreateCourierForm = ({ closeModal, loading, apiError, createCourier }) => (
  <FormModalShell
    title="Add Courier"
    apiError={apiError}
    onClose={closeModal}
    columns={3}
  >
    <Formik
      initialValues={{
        phone: "",
        firstName: "",
        lastName: "",
        email: "",
        password1: "",
        password2: ""
      }}
      validationSchema={Yup.object().shape({
        phone: yupPhone,
        firstName: yupFirstName,
        lastName: yupLastName,
        email: yupEmail,
        password1: yupPassword,
        password2: Yup.string()
          .oneOf([Yup.ref("password1")], "Passwords must match")
          .required("Required field")
      })}
      onSubmit={values => {
        createCourier(values);
      }}
    >
      {() => (
        <Form>
          <CourierText label="Phone" name="phone" placeholder="03xxxxxxxxx" />
          <CourierText label="First Name" name="firstName" placeholder="John" />
          <CourierText label="Last Name" name="lastName" placeholder="Doe" />
          <CourierText label="Email" name="email" span />
          <CourierText label="Password" name="password1" type="password" />
          <CourierText
            label="Confirm Password"
            name="password2"
            type="password"
          />
          <CourierActions
            loading={loading}
            submitLabel="Add Courier"
            onCancel={closeModal}
          />
        </Form>
      )}
    </Formik>
  </FormModalShell>
);

export default CreateCourierForm;
